export interface FeatureFlag {
  id: string;
  featureName: string;
  isEnabled: boolean;
  isPaid: boolean;
  planName?: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export type FeatureFlagName = string;
/**
 * Feature flags constants
 * 
 * @description This constant object contains the feature flag names used throughout the application.
 * These names correspond to the `feature_name` field in the `feature_flags` table.
 * Used for feature flag checking and management.
 * Add new feature flags here to use them in the application. 
 */
export const FEATURE_FLAGS = {
  /** Digital invoices feature flag name */
  DIGITAL_INVOICES: 'digitalInvoices',
  /** AI (Artificial Intelligence) feature flag name */
  AI_INSIGHTS: 'aiInsights',
  /** Promotional products feature flag name */
  PROMOTIONS: 'promoProducts',
  /** Composite products / ingredients recipes feature flag name */
  COMPOSITE_PRODUCTS: 'compositeProducts',
  /** External orders integration feature flag name */
  EXTERNAL_ORDERS: 'externalOrders',
  /** Kitchen Display System (KDS) feature flag name */
  KITCHEN_VIEW: 'kitchenView',
  HIDE_TABLE_VIEW: 'hideTableView',
  TABS_REALTIME: 'tabsRealtime',
  XML_INVOICE_IMPORT: 'xmlInvoiceImport',
  /** Allows to indicate the position in the table where the product should be served */
  CUSTOMER_POSITIONS: 'customerPositions',
  /** Per-shift cash closures (create/record shifts before daily balance) */
  SHIFT_CLOSURES: 'shiftClosures',
  /** Tip handling (close tab toggle, cash reconciliation, sales card and Excel column) */
  TIPPING: 'tipping',
  /** Per-product day-of-week availability (daily menu) feature flag name */
  WEEKDAY_AVAILABILITY: 'weekdayAvailability',
  /** Client reservations calendar */
  RESERVATIONS: 'reservations',
  /**
   * Modifiers stored per tab line with price and ingredient deduction.
   * Enable per org only once all its devices run a build that supports it.
   */
  PRICED_MODIFIERS: 'pricedModifiers',
  SOLD_BY_WEIGHT: 'soldByWeight',
  /**
   * Cashier printer can print one combined copy of kitchen and bar dispatch tickets.
   */
  CASHIER_DISPATCH_COPY: 'cashierDispatchCopy',
} as const;


